<template>
  <div class="CSearchLisit">
    <div class="headDiv flex">
      <div class="headItem flex">
        <div class="item item1">产品编号</div>
        <div class="item item2">产品名称</div>
      </div>
      <div>选择</div>
    </div>
    <div class="list" v-if="productList!=''">
      <el-checkbox-group v-model="checkList">
        <el-checkbox v-for="(item,index) in productList" :label="item.sn" :key="index">
          <div class="item item1">{{item.sn}}</div>
          <div class="item item2">{{item.product_name}}</div>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="list noList" v-else>暂无库存</div>
    <div class="btnDiv">
      <el-button @click="backUp">返回</el-button>
      <el-button @click="searchCheck">搜索</el-button>
    </div>
  </div>
</template>
<script>
import { wareApi } from "../../../../../../static/js/api.js"
import * as config from '../../../../../../static/js/config.js';
export default {
  name:'CSearchLisit',
  data(){
    return {
      checkList:[],
      productList:[],
    }
  },
  created(){
    var checkInfo = JSON.parse(sessionStorage.getItem('checkInfo'))
    if(checkInfo){
      for(var i in checkInfo){
        this.checkList.push(checkInfo[i].sn)
      }
    }
    this.getWareList()
  },
  methods:{
    //搜索
    searchCheck(){
      var that = this
      var arr = []
      for(var i in this.productList){
        for(var x in that.checkList){
          if(that.productList[i].sn == that.checkList[x]){
            arr.push(that.productList[i])
          }
        }
      }
      sessionStorage.setItem('checkInfo',JSON.stringify(arr))
      this.backUp()
    },
    //获取库存列表
    async getWareList(){
      var that = this
      var data = {
        'device_no_id':config.deviceId.split(','),
        'name':'',
      }
      var res = await wareApi.showProduct(data)
      if (res.meta.code == 200) {
        
        //去重处理
        var result = [],arr = [];
        var obj = {};
        arr = res.body
        // console.log(arr)
        for(var i =0; i < arr.length; i++){
          if(!obj[arr[i].sn]){
            result.push(arr[i]);
            obj[arr[i].sn] = true;
          }
        }
        that.productList = result

        // that.productList = res.body
      } else {
        that.$message.error(res.meta.message)
      }
    },
    
    //返回
    backUp(){
      this.$router.push({
        path:'/toolCabinet/CBorrow',
      })
    },
  },
}
</script>
<style lang="less">
.CSearchLisit{
  .item1{ width: 40%}
  .item2{ width: 60%}
  .headDiv{
    align-items: center;
    justify-content: space-between;
    height: 1rem;
    border-bottom: 0.01rem solid #fff;
    padding: 0 0.4rem;
    box-sizing: border-box;
    font-size: 0.4rem;
    font-weight: bold;
    .headItem{
      width: 70%;
    }
  }
  .list{
    height: calc(100vh - 2.34rem);
    overflow: auto;
    &.noList{
      text-align: center;
      font-size: 0.5rem;
      color: #999;
      padding-top: 1rem;
      box-sizing: border-box;
    }
    .el-checkbox{
      display: flex;
      justify-content: space-between;
      flex-direction:row-reverse;
      align-items: center;
      margin: 0;
      padding: 0.4rem;
      border-bottom: 0.01rem solid #fff;
      .el-checkbox__inner{
        width: 0.5rem;
        height: 0.5rem;
        border:0.01rem solid #DCDFE6;
        border-radius: 50%;
        &::after{
          border: 0.01rem solid #fff;
          border-left: 0;
          border-top: 0;
          width: 0.12rem;
          height: 0.26rem;
          left: 50%;
          margin-left: -0.06rem;
          top: 50%;
          margin-top: -0.18rem;
        }
        
      }
      .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #67C23A;
      }
      .el-checkbox__label{
        display: flex;
        align-items: center;
        font-size: 0.35rem;
        width: 70%;
        color: #fff;
      }
    }
  }
  .btnDiv{
    text-align: right;
    padding: 0.2rem;
    background-color: rgba(0, 0, 0, .21);
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CBorrow/CSearchList.vue